export default __webpack_public_path__ + "static/media/acControllerIcon.d9ab0286.svg";